

import { useQuery } from "react-query";
import { getTeacherEvaluation, getTeachersEvaluationsCriteriasReport } from "../services/school/teacher/teacherEvaluationCriteria";
import { PagedRequestType } from "../types/PagedResults";
import { Key_teacherevaluations, Key_teacherevaluationsreport } from "../utils/constants";

export const useGetTeacherEvaluationsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_teacherevaluations, JSON.stringify(data)],
    () => getTeacherEvaluation(data),
    options?{...options}:{}
  );

  export const useGetTeacherEvaluationsReportQuery = (data: PagedRequestType, options:any= null) =>
    useQuery(
      [Key_teacherevaluationsreport, JSON.stringify(data)],
      () => getTeachersEvaluationsCriteriasReport(data),
      options?{...options}:{}
    );